export const settingsDataSelector = (state) => state.settings.data;
export const settingsGetInProcessSelector = (state) => state.settings.getInProcess;
export const settingsUpdateInProcessSelector = (state) => state.settings.updateInProcess;
export const settingsErrorsSelector = state => state.settings.errors;

export const settingsDeliveryZipsSelector = state => state.settings.deliveryZips;
export const deliveryActiveTabSelector = state => state.settings.deliverActiveTab;
export const settingsLoadingStatusesSelector = state => state.settings.loadingStatuses;
export const deliveryDatesSelector = state => state.settings.deliveryDates;
